import { Flex } from '@mantine/core';
import { Button, Icon, Text } from '@repo/foundations';

export function AnalyticsBanner({
	handleNavigate,
}: {
	handleNavigate: () => void;
}) {
	return (
		<Flex justify="space-between" mb="md">
			<Flex align="center" gap="2xs">
				<Icon name="chartBar" />
				<Text fz="sm" sx={{ cursor: 'default' }}>
					Analytics
				</Text>
			</Flex>
			<Button fz="sm" variant="plain" size="sm" onClick={handleNavigate}>
				View more analytics
			</Button>
		</Flex>
	);
}
